import './App.css';

import { useEffect, useState, useCallback } from "react";

function BingaMobile({ token }) {
  const [expenses, setExpenses] = useState([]);
  const [incomes, setIncomes] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_URL = process.env.REACT_APP_API_URL; // change selon ton backend

  const [budgets, setBudgets] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState(null);

  
  // fetch budget 
  const fetchBudgets = useCallback(async () => {
    // On s'assure de ne rien faire si le jeton n'est pas présent
    if (!token) {
      console.error("Tentative de fetch des budgets sans jeton.");
      return;
    }

    try {
      const res = await fetch(`${API_URL}/budget`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      // Gérer les réponses d'erreur (ex: 401 Unauthorized)
      if (!res.ok) {
        throw new Error(`Erreur du serveur: ${res.status}`);
      }

      const data = await res.json();
      
      // trier par start_date croissant
      const sorted = data.sort(
        (a, b) =>
          new Date(a.start_date).getTime() - new Date(b.start_date).getTime()
      );
      setBudgets(sorted);
    } catch (err) {
      console.error("Erreur fetch budgets:", err);
    }
  }, [token, API_URL]);

  // --- Fetch Expenses ---
  const fetchExpenses = useCallback(async () => {
    const res = await fetch(`${API_URL}/expenses?start_date=${selectedBudget.start_date}&end_date=${selectedBudget.end_date}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    const data = await res.json();
    // Tri par group puis par category
    data.sort((a, b) => {
      if (a.group === b.group) {
        return a.category.localeCompare(b.category);
      }
      return a.group.localeCompare(b.group);
    });
    setExpenses(data);
  }, [selectedBudget, token, API_URL]);

  // --- Fetch Incomes ---
  const fetchIncomes = useCallback(async () => {
    const res = await fetch(`${API_URL}/income?start_date=${selectedBudget.start_date}&end_date=${selectedBudget.end_date}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
    const data = await res.json();
    setIncomes(data);
  }, [selectedBudget, token, API_URL]);


  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await fetchBudgets();
      // await fetchExpenses();
      // await fetchIncomes();
      setLoading(false);
    };
    load();
  }, [fetchBudgets]);

  useEffect(() => {
    if (!selectedBudget) return;

    const fetchData = async () => {
      await fetchExpenses();
      await fetchIncomes();
    };

    fetchData();
  }, [selectedBudget, fetchExpenses, fetchIncomes]);

  const totalIncomes = incomes.reduce((sum, i) => sum + i.value, 0);
  const totalExpenses = expenses.reduce((sum, e) => sum + e.value, 0);
  const balance = totalIncomes - totalExpenses;
  const targets = {
    fix: 65,
    Envie: 20,
    Investissement: 15,
  };

  // //gestion par budget 
  // const loadData = async (budgetId) => {
    
  // };



  

  // Regroupement par group
  const grouped = expenses.reduce((acc, e) => {
    const g = e.group || "Autres";
    acc[g] = (acc[g] || 0) + e.value;
    return acc;
  }, {});
  // Convertir en tableau exploitable
  const rows = Object.entries(grouped).map(([group, sum]) => {
    const percentage = totalExpenses ? (sum / totalExpenses) * 100 : 0;
    const target = targets[group] ?? 0;
    let colorClass = "bg-white";

    if (group in targets) {
      if (group === "Investissement") {
        colorClass = percentage < target ? "bg-red-200" : "bg-green-100";
      } else {
        colorClass = percentage > target ? "bg-red-200" : "bg-green-100";
      }
    } else {
      colorClass = "bg-purple-200";
    }

    return {
      group,
      sum,
      percentage,
      target,
      colorClass,
    };
  });

  // Tableau 1 : comptes avec total des dépenses
  const accountTotals = expenses.reduce((acc, e) => {
    const account = e.account || "Sans compte";
    acc[account] = (acc[account] || 0) + e.value;
    return acc;
  }, {});

  // Tableau 2 : expenses avec need_to_pay = true
  const toPayExpenses = expenses.filter((e) => e.need_to_pay);


 
 




  if (loading) return <div className="p-4">Loading...</div>;

  return (
    
    <div className="p-6 bg-gray-100 min-h-screen space-y-10">
      {/* Boutons budgets */}
      <div className="flex space-x-2 overflow-x-auto">
        {budgets.map((budget) => (
          <button
            key={budget._id}
            onClick={() => setSelectedBudget(budget)}
            className={`px-4 py-2 rounded-lg text-sm font-medium 
              ${
                selectedBudget?._id === budget._id
                  ? "bg-blue-600 text-white"
                  : "bg-gray-200 text-gray-700 hover:bg-gray-300"
              }`}
          >
            {budget.name}
          </button>
        ))}
      </div>

      {selectedBudget && (
        <>
      
        <div className="grid grid-cols-1 gap-6 mt-6">
          {/* Incomes */}
          <div className="bg-green-100 text-green-800 p-6 rounded-2xl shadow">
            <h3 className="text-lg font-bold">Total Incomes</h3>
            <p className="text-2xl font-extrabold">{totalIncomes.toFixed(2)} €</p>
          </div>

          {/* Expenses */}
          <div className="bg-red-100 text-red-800 p-6 rounded-2xl shadow">
            <h3 className="text-lg font-bold">Total Expenses</h3>
            <p className="text-2xl font-extrabold">{totalExpenses.toFixed(2)} €</p>
          </div>

          {/* Balance */}
          <div
            className={`p-6 rounded-2xl shadow ${
              balance >= 0 ? "bg-blue-100 text-blue-800" : "bg-orange-100 text-orange-800"
            }`}
          >
            <h3 className="text-lg font-bold">Balance</h3>
            <p className="text-2xl font-extrabold">{balance.toFixed(2)} €</p>
          </div>
          
        </div>

        <div className="grid grid-cols-1 gap-6 mt-6">

        <div className="mt-8">
          <h2 className="text-xl font-bold mb-4">Dépenses par Group</h2>
          <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 text-left">Group</th>
                <th className="px-4 py-2 text-right">Somme</th>
                <th className="px-4 py-2 text-right">%</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.group} className={`${row.colorClass}`}>
                  <td className="px-4 py-2">{row.group}</td>
                  <td className="px-4 py-2 text-right">{row.sum.toFixed(2)}</td>
                  <td className="px-4 py-2 text-right">{row.percentage.toFixed(1)}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8">
          {/* Tableau des virements */}
          <h2 className="text-xl font-bold mb-4">Comptes et Totaux des Dépenses</h2>
          <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden mb-8">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 text-left">Compte</th>
                <th className="px-4 py-2 text-right">Total Dépenses</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(accountTotals).map(([account, total]) => (
                <tr key={account} className="bg-white">
                  <td className="px-4 py-2">{account}</td>
                  <td className="px-4 py-2 text-right">{total.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          <div className="mt-8">

          {/* Tableau des payement à faire */}
          <h2 className="text-xl font-bold mb-4">Dépenses à Payer (need_to_pay)</h2>
          <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 text-left">Nom</th>
                <th className="px-4 py-2 text-left">Compte</th>
                <th className="px-4 py-2 text-right">Montant</th>
              </tr>
            </thead>
            <tbody>
              {toPayExpenses.map((exp) => (
                <tr key={exp._id} className="bg-yellow-100">
                  <td className="px-4 py-2">{exp.name}</td>
                  <td className="px-4 py-2">{exp.account || "Sans compte"}</td>
                  <td className="px-4 py-2 text-right">{exp.value.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      

      </div>


      {/* --- Expenses Table --- */}
      <div className="bg-white p-4 rounded shadow">
        <h2 className="text-xl font-bold mb-4 text-center">Expenses</h2>

        <div className="grid gap-3">
          {expenses.map((exp) => (
            <div
              key={exp._id}
              className="border rounded-xl p-3 shadow-sm bg-gray-50 hover:shadow-md transition-all"
            >
              <div className="flex justify-between items-center mb-2">
                <span className="font-semibold text-gray-800">{exp.name}</span>
                <span className="text-blue-600 font-bold">{exp.value} €</span>
              </div>

              <div className="flex flex-wrap text-sm text-gray-600">
                <div className="w-1/2">📁 Catégorie : <span className="font-medium">{exp.category}</span></div>
                <div className="w-1/2">🏦 Compte : <span className="font-medium">{exp.account}</span></div>
                <div className="w-full mt-1">👥 Groupe : <span className="font-medium">{exp.group}</span></div>
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* --- Incomes Table --- */}
      <div className="bg-white p-4 rounded shadow">
        <h2 className="text-xl font-bold mb-4 text-center">Incomes</h2>

        <div className="grid gap-3">
          {incomes.map((inc) => (
            <div
              key={inc._id}
              className="border rounded-xl p-3 shadow-sm bg-green-50 hover:shadow-md transition-all"
            >
              <div className="flex justify-between items-center mb-1">
                <span className="font-semibold text-gray-800">{inc.name}</span>
                <span className="text-green-700 font-bold">{inc.value} €</span>
              </div>

              {inc.income_date && (
                <div className="text-sm text-gray-600 mt-1">
                  📅 Date :{" "}
                  <span className="font-medium">
                    {new Date(inc.income_date).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      </>
      )}
    </div>
  );
}



export default BingaMobile;
